import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpHeaders } from '@angular/common/http';
import { SimpleEntityBackendService } from '../../../../../shared/services/searchable-entity/simple-entity/simple-entity-backend.service';
import { WaveReleaseDataService } from './wave-release-data.service';
import { CoreServiceRegistry } from '../../../../../core/core-service-registry';
import { SharedServiceRegistry } from '../../../../../shared/shared-service-registry';
import { TablePreference } from '../../../../../shared/search/models/table-preference.model';
import { LoaderEnabled } from '../../../../../shared/components/loader/loader.service';
import { HttpStatusCode } from 'app/shared/models/http-status-code.constants';


@Injectable()
export class WaveReleaseBackendService extends SimpleEntityBackendService {

  protected dataService: WaveReleaseDataService;

  constructor(protected coreServiceRegistry: CoreServiceRegistry,
    protected sharedServiceRegistry: SharedServiceRegistry) {
    super(coreServiceRegistry, sharedServiceRegistry);
  }

  public fetchTablePreferences(): Observable<Response> {
    const tableId: string = 'wavereleasesearchtd';
    const tablePreferenceFetch$: any = this.http$.get(`api/core/user/tablepreferences/` + tableId + '/');
    return tablePreferenceFetch$
      .map((response: any) => {
        return response;
      }).catch((error: any) => {
        // Lets not stop navigation. Continue as if there is no preference set
        return Observable.of(new TablePreference());
      });

  }



  /* API will update the BuildParam used values, i.e Build_Values used by SP for build/create etc..
    Then build the Waves if request['buildWave'] == 'Y'
    Refresh only if request['buildWave'] == 'N'

    Update statement to Update the BuildValues and then calls
    WM.lsp_WaveCreate - To Build the Waves as per selected conditions.
    */
  @LoaderEnabled()
  public buildWave(request: any, isRefreshOnly: boolean) {

    // API to only update the BuildParam used values, i.e Build Values used by SP for build/create etc..
    const updateParamBuildValuesUrl = 'api/outbound/waverelease/wave/refresh';
    // API to update BuildParam used values, and then Build Wave
    const updateParamBuildValuesAndCreateWaveUrl = `api/outbound/waverelease/wave/build`;

    const finalURl = (isRefreshOnly) ? updateParamBuildValuesUrl : updateParamBuildValuesAndCreateWaveUrl;

    //   const finalURl = 'api/outbound/waverelease/wave/build';
    const response$ = this.http$.put(finalURl, JSON.stringify(request))
      .map((response: any) => {
        return response;
      }).catch((error: any) => {
        const errors = error.error.errors || [];
        if (errors.length !== 0) {
          // previously the validationCode is 0 which is false, add an undefined check
          // [UWP-56867] Wave Release is showing err msg of "undefined-undefined"
          if (errors[0].validationCode !== undefined && errors[0].validationCode !== HttpStatusCode.ok) {
            return Observable.throw(errors[0].validationMessage);
          } else if (error.status === HttpStatusCode.badRequest) {
            return Observable.throw(errors[0].defaultMessage + ' - ' +
            errors[0].rejectedValue);
          }
        }
      });
    return response$;
  }

  /* Geeneric Delete method */
  public delete(request: any): Observable<Response> {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: request,
    };

    const response$ = this.http$.delete('api/setup/', options)
      .map((response: any) => {
        return response;
      })
      .catch((error: any) => {
        if (error.error.length !== 0) {
          if (error.error.statusCode !== 200) {
            return Observable.throw(error.error.statusMessage);
          }
        }
      });
    return response$;
  }

  /* delete method for x button */
  public deleteWaveXButton(request: any): Observable<Response> {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: request,
    };

    const response$ = this.http$.delete('api/wave/delete', options)
      .map((response: any) => {
        return response;
      })
      .catch((error: any) => {
        if (error.error.length !== 0) {
          if (error.error.statusCode !== 200) {
            return Observable.throw(error.error.statusMessage);
          }
        }
      });
    return response$;
  }

  /* Not used now
  The clear SP call is now unused.
  BuildParams:> The BuildValue for parameters will be copied from Value and saved to DB on EDIT/ADD .
   While building IN conditions will be checked by default.
  If user unchecks all IN will go as blank in BuildValue.
  BuildRestrictions:> The default value will be shown on load of Create screen and
  will be used to update BuildValue column.
   Will be read from default (value) column if Checkbox is not checked.
  If checked new values will be updated.
  */
  public clearApi(buildParam) {
    const response$ = this.http$.get(`api/outbound/waverelease/wave/` + buildParam + `/clear`)
      .map((response: any) => {
        return response;
      }).catch((error: any) => {
        if (error.error.length !== 0) {
          if (error.error.statusCode !== 200) {
            return Observable.throw(error.error.statusMessage);
          }
        }
      });
    return response$;
  }

  // service call to save Order Parameters
  public saveEntityforUpdate(request: any) {

    const response$ = this.http$.put(`api/setup/`, JSON.stringify(request)).map((response: any) => {
      return response;
    }).catch((error: any) => {
      if (error.error.length !== 0) {
        if (error.error.statusCode && error.error.statusCode !== 200) {
          return Observable.throw(error.error.statusMessage);
        } else if (error.status === 400) {
          return Observable.throw(error.error.message + ' - ' + error.error.invalidValue);
        }
      }
    });
    return response$;
  }



  // service call to delete selected line items of an entity - editorderparam popup
  public deleteSelectedLineItemFromEntity(itemNumber: any, selectedLineItemNumbers: any, idProperty): Observable<Response> {
    const lineItemListReq: any = [];
    selectedLineItemNumbers.forEach((lineItemNo: any) => {
      let moduleProp: any = null;
      let request: any = null;

      moduleProp = [{ cName: idProperty, cVal: lineItemNo.value },
      { cName: 'buildparmkey', cVal: itemNumber }];
      request = {
        'screenType': 'BUILDPARMDETTD',
        'moduleProperties': moduleProp
      };
      lineItemListReq.push(request);

    }); const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: lineItemListReq,
    };
    const response$ = this.http$.delete('api/setup/', options)
      .map((response: any) => {
        if (response['errors']) {
          if (response['errors'][0].validationCode !== 200) {
            return Observable.throw(response['errors'][0].validationMessage);
          }
        } else {
          return response;
        }
      }).catch((error: any) => {
        if (error.error.length !== 0) {
          if (error.error.statusCode !== 200) {
            return Observable.throw(error.error.statusMessage);
          }
        }
      });
    return response$;
  }

  /* Used for fieldname dropdown population in editOrderParam Popup
  */
  public populateRestrictedValues(type) {
    // LFWM-3191-adding tableId
    const tableId: string = 'wavereleasesearchtd';
    const response$ = this.http$.get('api/order/fieldname/'+type+ '/' + tableId +'/values')
      .map((response: any) => {
        return response;
      })
      .catch((error: any) => {
        if (error.error.errors.length !== 0) {
          if (error.error.errors[0].validationCode !== 200) {
            return Observable.throw(error.error.errors['0'].validationMessage);
          }
        }
      });
    return response$;
  }


/*
    To fetch the top 20 distinct values for each column passed as array
    of format [TABLENAME.COLUMNAME,...,...].
    ** Used to populate Checkbox values for IN Conditions with blank data saved
*/
  public fetchTop20ForInConditionParams(request): Observable<Response> {

    const top20InValues$: any = this.http$.post(`api/outbound/waverelease/wave/param/details`, JSON.stringify(request));
    return top20InValues$
      .map((response: any) => {
        return response;
      }).catch((error: any) => {
        if (error.error.errors.length !== 0) {
          if (error.error.errors[0].validationCode !== 200) {
            return Observable.throw(error.error.errors['0'].validationMessage);
          }
        }
      });

  }
  // LFWM-3191- made a new api /withPriv (replacement for setup api)
  //  to pass the privileges for checking the privileges at the backend level.
  // service call to save Order Parameters
  public saveEntityforUpdateWithPrivilege(request: any) {

    const response$ = this.http$.put(`api/setup/withPriv/`, JSON.stringify(request)).map((response: any) => {
      return response;
      // LFWM-3191-handling 403-forbidden error.
    }).catch((error: any) => {
      if (error.error.length !== 0) {
        if (error.error.status === 403) {
          return Observable.throw(error.error.message);
        } else if (error.error.statusCode && error.error.statusCode !== 200) {
          return Observable.throw(error.error.statusMessage);
        } else if (error.status === 400) {
          return Observable.throw(error.error.message + ' - ' + error.error.invalidValue);
        }
      }
    });
    return response$;
  }

  // LFWM-3191- made a new api /withPriv (replacement for setup api)
  //  to pass the privileges for checking the privileges at the backend level.
  // service call to delete selected line items of an entity - editorderparam popup
  public deleteSelectedLineItemFromEntityWithPriv(itemNumber: any, selectedLineItemNumbers: any, idProperty, privilege: any): Observable<Response> {
    const lineItemListReq: any = [];
    selectedLineItemNumbers.forEach((lineItemNo: any) => {
      let moduleProp: any = null;
      let request: any = null;

      moduleProp = [{ cName: idProperty, cVal: lineItemNo.value },
      { cName: 'buildparmkey', cVal: itemNumber }];
      request = {
        'screenType': 'BUILDPARMDETTD',
        'moduleProperties': moduleProp,
        'privilege': privilege
      };
      lineItemListReq.push(request);

    }); const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: lineItemListReq,
    };
    const response$ = this.http$.delete('api/setup/withPriv/', options)
      .map((response: any) => {
        if (response['errors']) {
          if (response['errors'][0].validationCode !== 200) {
            return Observable.throw(response['errors'][0].validationMessage);
          }
        } else {
          return response;
        }
        // LFWM-3191-handling 403-forbidden error.
      }).catch((error: any) => {
        if (error.error.status === 403) {
          return Observable.throw(error.error.message);
        } else if (error.error.length !== 0) {
          if (error.error.statusCode !== 200) {
            return Observable.throw(error.error.statusMessage);
          }
        }
      });
    return response$;
  }


// LFWM-3470/LFWM-3697 Add new API for Validate Build Date Field
// LFWM-3764- At first, buildparamgroup was coming as null, So getting the value from summary component
  public validateBuildDateField(buildParamGroup: any): Observable<any> {
    const request = {
      'storerKey': this.dataService.waveSummarySearchParams['storerKey'],
      'facility': this.dataService.waveSummarySearchParams['facility'],
      'buildParmGroup': buildParamGroup
    };
    return this.http$.post(`api/outbound/waverelease/wave/validate/builddatefield`, JSON.stringify(request));
  }
}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/features/outbound/wave-release/wave-release-home/services/wave-release-backend.service.ts